import { clsx } from 'clsx';
import capitalize from 'lodash/capitalize';
import { CSSProperties, forwardRef, PropsWithChildren } from 'react';
import { isDefined } from '~/types/typeGuards';
import { spacing } from '~/utils/styles';
import styles from './Card.module.scss';

export type CardProps = {
  className?: string;
  padding?: 0 | 1 | 2 | 3 | 4 | 5;
  radius?: 'small' | 'medium' | 'large' | 'full';
  stroke?: 'none' | 'small' | 'medium' | 'large';
  shadow?: 'none' | 'small' | 'medium' | 'large';
  bgColor?: CSSProperties['color'] | undefined;
  id?: string;
  style?: CSSProperties;
} & Record<`data-${string}`, unknown>;

const Card = forwardRef<HTMLDivElement, PropsWithChildren<CardProps>>(
  (
    { children, className, padding, radius = 'small', shadow = 'small', stroke = 'small', bgColor, style, ...attrs },
    ref,
  ) => {
    const computedStyle = { ...style };
    if (isDefined(padding) && !isDefined(computedStyle.padding)) computedStyle.padding = spacing(padding);
    if (isDefined(bgColor)) computedStyle.backgroundColor = bgColor;

    return (
      <div
        {...attrs}
        ref={ref}
        className={clsx(
          styles.root,
          styles[`radius${capitalize(radius)}`],
          styles[`stroke${capitalize(stroke)}`],
          styles[`shadow${capitalize(shadow)}`],
          className,
        )}
        style={computedStyle}
      >
        {children}
      </div>
    );
  },
);

export default Card;
